// import VueCookie from 'vue-cookie'
import Cookies from 'js-cookie'
export default {
  getShop() {
    let cookieData = {}
    if (process.server) {
      const nuxtApp = useNuxtApp()
      if (nuxtApp && nuxtApp.ssrContext && nuxtApp.ssrContext.event && nuxtApp.ssrContext.event.req) {
        const req = nuxtApp.ssrContext.event.req
        cookieData = this.getInServer(req)

        // 服务器端根据域名判断
        const host = req.headers.host
        const protocol = req.headers['x-forwarded-proto'] || (req.connection.encrypted ? 'https' : 'http')
        const origin = `${protocol}://${host}`

        // 根据域名设置特定的 shopIcon
        if (host === 'xwyh.shanxiyixue.com') {
          cookieData.shopIcon = `${origin}/_nuxt/assets/logo/xwyh.png`
          cookieData.shopName = '希望易学'
        }
        else if (host === 'xue.coeedu.cn') {
          cookieData.shopIcon = `${origin}/_nuxt/assets/logo/zyjy.png`
          cookieData.shopName = '卓越教育'
        }
        else if (host === 'guozijy.com' || host === 'www.guozijy.com') {
          cookieData.shopIcon = `${origin}/_nuxt/assets/logo/guozi.png`
          cookieData.shopName = '国子教育'
        }
        else if (host === 'kecheng.wuyouyanxue.cn') {
          // favicon 取 public 下的固定路径（assets 目录构建后带 hash，硬编码路径会 404）
          cookieData.shopIcon = `${origin}/logo/wyyx1.png`
          cookieData.shopName = '无忧研学'
        }
      }
    } else {
      cookieData = {
        shopIcon:
          location.origin.includes('xwyh.shanxiyixue.com')
            ? `${location.origin}/_nuxt/assets/logo/xwyh.png`
            : location.origin.includes('xue.coeedu.cn')
              ? `${location.origin}/_nuxt/assets/logo/zyjy1.png`
              : location.origin.includes('guozijy.com')
                ? `${location.origin}/_nuxt/assets/logo/guozi.png`
                : location.origin.includes('kecheng.wuyouyanxue.cn')
                  ? `${location.origin}/logo/wyyx1.png`
                  : this.getInClient('shopIcon'),

        shopName:
          location.origin.includes('xwyh.shanxiyixue.com')
            ? '希望易学'
            : location.origin.includes('xue.coeedu.cn')
              ? '卓越教育'
              : location.origin.includes('guozijy.com')
                ? '国子教育'
                : location.origin.includes('kecheng.wuyouyanxue.cn')
                  ? '无忧研学'
                  : this.getInClient('shopName')
      }
    }
    return cookieData
  },
  // 获取服务端cookie
  getInServer(req) {
    const serviceCookie = {}
    req && req.headers.cookie && req.headers.cookie.split(';').forEach(function (val) {
      const parts = val.split('=')
      serviceCookie[parts[0].trim()] = decodeURIComponent((parts[1] || '').trim())
    })
    return serviceCookie
  },

  setInServer(Cookie, req) {
    if (Cookie.constructor == Object) {
      let cssStr = ''
      for (const key in Cookie) {
        cssStr += key + '=' + Cookie[key] + ';'
      }
      req.headers.cookie = cssStr.slice(0, cssStr.length - 1)
      return cssStr.slice(0, cssStr.length - 1)
    }
  },
  // 获取客户端cookie
  getInClient(key) {
    const tokenInfo = Cookies.get(key)
    return tokenInfo
  },
  // 获取客户端cookie
  setInClient({ key, val, expires = 1 }) {
    const hostname = window.location.hostname
    const option = {
      expires
    }
    if (hostname !== 'localhost') {
      option.domain = hostname
    }
    if (hostname === '127.0.0.1') {
      delete option.domain
    }
    Cookies.set(key, val, option)
  },
  // 删除客户端cookie
  delInClient(key) {
    const hostname = window.location.hostname
    const option = {
      expires: 1
    }
    if (hostname !== 'localhost') {
      option.domain = hostname
    }
    if (hostname === '127.0.0.1') {
      delete option.domain
    }
    Cookies.remove(key, option)
  }
}
